export const ALL = 'all_participants'
export const COMPLETED = 'only_completed_evaluations'
export const INCOMPLETE = 'only_incomplete_evaluations'

export const OPTIONS = [ALL, COMPLETED, INCOMPLETE]
